import React from "react";
import CreateContentField from "./CreateContentField";
import { Box, Card, Switch, TextField } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { TwoForOneModel } from "../../../types/generalContent";
import { CollapseState } from "../GeneralContent";
import AddIcon from "@material-ui/icons/AddCircleOutline";
import RemoveIcon from "@material-ui/icons/RemoveCircleOutline";
import UpIcon from "@material-ui/icons/ArrowDropUp";
import DownIcon from "@material-ui/icons/ArrowDropDown";

interface TwoForOneCardsProps {
  state: TwoForOneModel;
  collapseState: CollapseState;
  toggleCard: (name: string) => void;
  errors: Record<string, string>;
  handleChange: (e: any) => void;
  handleAddInfoDescription: (name: string, category: string) => void;
  handleRemoveInfoDescriptionItem: (i: string, j: string) => void;
  handleRemoveContentIconItem: (id: string, name: string) => void;
  handleRemoveContentDescriptionItem: (
    i: number,
    name: string,
    category: string,
  ) => void;
  handleChangeItemStatus: (name: string, state: boolean) => void;
  moveAccordionItem: (index: number, direction: "up" | "down") => void;
  handleRemoveAccordionItem: (id: string) => void;
  handleRemoveGalleryItem: (i: number, name: string) => void;
  handleAddFaqItem: () => void;
  handleRemoveFaqItem: (faqId: string) => void;
  handleAddFaqAnswer: (faqIndex: number) => void;
  handleRemoveFaqAnswer: (faqIndex: number, answerIndex: number) => void;
}

const TwoForOneCards = ({
  state,
  collapseState,
  toggleCard,
  errors,
  handleChange,
  handleAddInfoDescription,
  handleRemoveInfoDescriptionItem,
  handleRemoveContentIconItem,
  handleRemoveContentDescriptionItem,
  handleChangeItemStatus,
  moveAccordionItem,
  handleRemoveAccordionItem,
  handleRemoveGalleryItem,
  handleAddFaqItem,
  handleRemoveFaqItem,
  handleAddFaqAnswer,
  handleRemoveFaqAnswer,
}: TwoForOneCardsProps) => {
  return (
    <div className="content__section">
      <Box className="content__box">
        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoVideo ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoVideo")}
          >
            Video
          </span>
          <Collapse in={collapseState.tfoVideo}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.title"
                      error={!!errors[`twoForOne.video.title`]}
                      helperText={errors[`twoForOne.video.title`]}
                      onChange={handleChange}
                      value={state.video.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge Price:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.badgePrice"
                      onChange={handleChange}
                      value={state.video.badgePrice}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Badge URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.badgeUrl"
                      onChange={handleChange}
                      value={state.video.badgeUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Video URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.videoDesktopUrl"
                      error={!!errors[`twoForOne.video.videoDesktopUrl`]}
                      helperText={errors[`twoForOne.video.videoDesktopUrl`]}
                      onChange={handleChange}
                      value={state.video.videoDesktopUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Video Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.videoMobileUrl"
                      error={!!errors[`twoForOne.video.videoMobileUrl`]}
                      helperText={errors[`twoForOne.video.videoMobileUrl`]}
                      onChange={handleChange}
                      value={state.video.videoMobileUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Video Preview URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.videoPreviewUrl"
                      error={!!errors[`twoForOne.video.videoPreviewUrl`]}
                      helperText={errors[`twoForOne.video.videoPreviewUrl`]}
                      onChange={handleChange}
                      value={state.video.videoPreviewUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Video Preview Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.video.videoPreviewMobileUrl"
                      error={!!errors[`twoForOne.video.videoPreviewMobileUrl`]}
                      helperText={
                        errors[`twoForOne.video.videoPreviewMobileUrl`]
                      }
                      onChange={handleChange}
                      value={state.video.videoPreviewMobileUrl}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Floor Plan URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.floorPlanUrl"
                      error={!!errors[`twoForOne.floorPlanUrl`]}
                      helperText={errors[`twoForOne.floorPlanUrl`]}
                      onChange={handleChange}
                      value={state.floorPlanUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Floor Plan Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.floorPlanMobileUrl"
                      error={!!errors[`twoForOne.floorPlanMobileUrl`]}
                      helperText={errors[`twoForOne.floorPlanMobileUrl`]}
                      onChange={handleChange}
                      value={state.floorPlanMobileUrl}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoInfo ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoInfo")}
          >
            Info
          </span>
          <Collapse in={collapseState.tfoInfo}>
            {state.info.map((info, i) => {
              return (
                <div className="content__fields-item" key={info._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.info[${i}].title`}
                            error={!!errors[`twoForOne.info[${i}].title`]}
                            helperText={errors[`twoForOne.info[${i}].title`]}
                            onChange={handleChange}
                            value={state.info[i].title}
                          />
                        </Box>
                      }
                    />
                    <button
                      className="content__add-btn"
                      type="button"
                      onClick={() =>
                        handleAddInfoDescription(
                          `twoForOne.info[${i}].description[${info.description.length}]`,
                          "info",
                        )
                      }
                    >
                      <AddIcon />
                    </button>
                  </div>

                  {info.description.map((descr, j) => {
                    return (
                      <div
                        className="content__fields-list-item"
                        key={descr._id}
                      >
                        <div className="content__fields-row">
                          <CreateContentField
                            fieldTitle="Subtitle:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`twoForOne.info[${i}].description[${j}].subtitle`}
                                  error={
                                    !!errors[
                                      `twoForOne.info[${i}].description[${j}].subtitle`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `twoForOne.info[${i}].description[${j}].subtitle`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={state.info[i].description[j].subtitle}
                                />
                              </Box>
                            }
                          />
                          <CreateContentField
                            fieldTitle="Text:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`twoForOne.info[${i}].description[${j}].text`}
                                  error={
                                    !!errors[
                                      `twoForOne.info[${i}].description[${j}].text`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `twoForOne.info[${i}].description[${j}].text`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={state.info[i].description[j].text}
                                />
                              </Box>
                            }
                          />
                          <CreateContentField
                            fieldTitle="Icon URL:"
                            field={
                              <Box>
                                <TextField
                                  label=""
                                  size="small"
                                  variant="outlined"
                                  type="text"
                                  name={`twoForOne.info[${i}].description[${j}].iconUrl`}
                                  error={
                                    !!errors[
                                      `twoForOne.info[${i}].description[${j}].iconUrl`
                                    ]
                                  }
                                  helperText={
                                    errors[
                                      `twoForOne.info[${i}].description[${j}].iconUrl`
                                    ]
                                  }
                                  onChange={handleChange}
                                  value={state.info[i].description[j].iconUrl}
                                />
                              </Box>
                            }
                          />
                          {info.description.length > 1 && (
                            <button
                              className="content__delete-btn"
                              type="button"
                              onClick={() =>
                                handleRemoveInfoDescriptionItem(
                                  info._id,
                                  descr._id,
                                )
                              }
                            >
                              <RemoveIcon />
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoContent ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoContent")}
          >
            Key Highlights
          </span>
          <Collapse in={collapseState.tfoContent}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Title:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.title"
                      error={!!errors[`twoForOne.content.title`]}
                      helperText={errors[`twoForOne.content.title`]}
                      onChange={handleChange}
                      value={state.content.title}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="Subtitle:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.subtitle"
                      error={!!errors[`twoForOne.content.subtitle`]}
                      helperText={errors[`twoForOne.content.subtitle`]}
                      onChange={handleChange}
                      value={state.content.subtitle}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row centered">
              <span className="content__item-label">Icons:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `twoForOne.content.icons[${state.content.icons.length}]`,
                    "icon",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.icons.map((icon, i) => {
              return (
                <div className="content__fields-list-item" key={icon._id}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Icon Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.content.icons[${i}].iconTitle`}
                            error={
                              !!errors[
                                `twoForOne.content.icons[${i}].iconTitle`
                              ]
                            }
                            helperText={
                              errors[`twoForOne.content.icons[${i}].iconTitle`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconTitle}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.content.icons[${i}].iconUrl`}
                            error={
                              !!errors[`twoForOne.content.icons[${i}].iconUrl`]
                            }
                            helperText={
                              errors[`twoForOne.content.icons[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.content.icons[${i}].iconDescription`}
                            error={
                              !!errors[
                                `twoForOne.content.icons[${i}].iconDescription`
                              ]
                            }
                            helperText={
                              errors[
                                `twoForOne.content.icons[${i}].iconDescription`
                              ]
                            }
                            onChange={handleChange}
                            value={state.content.icons[i].iconDescription || ""}
                          />
                        </Box>
                      }
                    />
                    {state.content.icons.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() =>
                          handleRemoveContentIconItem(icon._id, "twoForOne")
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}

            <div className="content__fields-row centered">
              <span className="content__item-label">Description:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `twoForOne.content.description[${state.content.description.length}]`,
                    "description",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.description.map((descr, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle=""
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.content.description[${i}]`}
                            error={
                              !!errors[`twoForOne.content.description[${i}]`]
                            }
                            helperText={
                              errors[`twoForOne.content.description[${i}]`]
                            }
                            onChange={handleChange}
                            value={descr}
                          />
                        </Box>
                      }
                    />
                    {state.content.description.length > 1 && (
                      <button
                        className="content__delete-btn centered"
                        type="button"
                        onClick={() =>
                          handleRemoveContentDescriptionItem(
                            i,
                            "description",
                            "twoForOne",
                          )
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
            <span className="content__item-label">Image:</span>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.imageUrl"
                      error={!!errors[`twoForOne.content.imageUrl`]}
                      helperText={errors[`twoForOne.content.imageUrl`]}
                      onChange={handleChange}
                      value={state.content.imageUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.imageX2Url"
                      error={!!errors[`twoForOne.content.imageX2Url`]}
                      helperText={errors[`twoForOne.content.imageX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageX2Url}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="image Mobile URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.imageMobileUrl"
                      error={!!errors[`twoForOne.content.imageMobileUrl`]}
                      helperText={errors[`twoForOne.content.imageMobileUrl`]}
                      onChange={handleChange}
                      value={state.content.imageMobileUrl}
                    />
                  </Box>
                }
              />
              <CreateContentField
                fieldTitle="image Mobile x2 URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.content.imageMobileX2Url"
                      error={!!errors[`twoForOne.content.imageMobileX2Url`]}
                      helperText={errors[`twoForOne.content.imageMobileX2Url`]}
                      onChange={handleChange}
                      value={state.content.imageMobileX2Url}
                    />
                  </Box>
                }
              />
            </div>

            <div className="content__fields-row centered">
              <span className="content__item-label">Image Text:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `twoForOne.content.imageText[${state.content.imageText.length}]`,
                    "description",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.content.imageText.map((text, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle=""
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.content.imageText[${i}]`}
                            error={
                              !!errors[`twoForOne.content.imageText[${i}]`]
                            }
                            helperText={
                              errors[`twoForOne.content.imageText[${i}]`]
                            }
                            onChange={handleChange}
                            value={text}
                          />
                        </Box>
                      }
                    />
                    {state.content.imageText.length > 1 && (
                      <button
                        className="content__delete-btn centered"
                        type="button"
                        onClick={() =>
                          handleRemoveContentDescriptionItem(
                            i,
                            "imageText",
                            "twoForOne",
                          )
                        }
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoAccordionData ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoAccordionData")}
          >
            Accordion
          </span>
          <Collapse in={collapseState.tfoAccordionData}>
            <div className="content__fields-row centered">
              <span className="content__item-label">accordion items:</span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `twoForOne.accordionData[${state.accordionData.length}]`,
                    "accordion",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.accordionData.map((acc, i) => {
              return (
                <div className="content__fields-list-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.accordionData[${i}].title`}
                            error={
                              !!errors[`twoForOne.accordionData[${i}].title`]
                            }
                            helperText={
                              errors[`twoForOne.accordionData[${i}].title`]
                            }
                            onChange={handleChange}
                            value={acc.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Icon URL"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.accordionData[${i}].iconUrl`}
                            error={
                              !!errors[`twoForOne.accordionData[${i}].iconUrl`]
                            }
                            helperText={
                              errors[`twoForOne.accordionData[${i}].iconUrl`]
                            }
                            onChange={handleChange}
                            value={acc.iconUrl}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Special"
                      field={
                        <Box>
                          <Switch
                            checked={acc.isSpecial || false}
                            onChange={(e) =>
                              handleChangeItemStatus(
                                `twoForOne.accordionData[${i}].isSpecial`,
                                e.target.checked,
                              )
                            }
                            color="primary"
                            name="checkedB"
                            inputProps={{ "aria-label": "primary checkbox" }}
                          />
                        </Box>
                      }
                    />
                    {state.accordionData.length > 1 && (
                      <div className="content__position-btns">
                        <button
                          className="content__position-btn"
                          type="button"
                          onClick={() => moveAccordionItem(i, "up")}
                        >
                          <UpIcon />
                        </button>
                        <button
                          className="content__position-btn"
                          type="button"
                          onClick={() => moveAccordionItem(i, "down")}
                        >
                          <DownIcon />
                        </button>
                      </div>
                    )}
                    {state.accordionData.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() => handleRemoveAccordionItem(acc._id)}
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                  <CreateContentField
                    fieldTitle="Description"
                    field={
                      <Box>
                        <TextField
                          label=""
                          size="small"
                          variant="outlined"
                          type="text"
                          name={`twoForOne.accordionData[${i}].description`}
                          error={
                            !!errors[
                              `twoForOne.accordionData[${i}].description`
                            ]
                          }
                          helperText={
                            errors[`twoForOne.accordionData[${i}].description`]
                          }
                          onChange={handleChange}
                          value={acc.description}
                        />
                      </Box>
                    }
                  />
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoStepperSubtitle ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoStepperSubtitle")}
          >
            Stepper
          </span>
          <Collapse in={collapseState.tfoStepperSubtitle}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Subtitle:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.stepperSubtitle"
                      error={!!errors[`twoForOne.stepperSubtitle`]}
                      helperText={errors[`twoForOne.stepperSubtitle`]}
                      onChange={handleChange}
                      value={state.stepperSubtitle || ""}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="Next Image URL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.nextImageUrl"
                      error={!!errors[`twoForOne.nextImageUrl`]}
                      helperText={errors[`twoForOne.nextImageUrl`]}
                      onChange={handleChange}
                      value={state.nextImageUrl || ""}
                    />
                  </Box>
                }
              />
            </div>
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoGallery ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoGallery")}
          >
            Gallery
          </span>
          <Collapse in={collapseState.tfoGallery}>
            <div className="content__fields-row centered">
              <span className="content__item-label">
                gallery slides({state.gallery.length}):
              </span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={() =>
                  handleAddInfoDescription(
                    `twoForOne.gallery[${state.gallery.length}]`,
                    "gallery",
                  )
                }
              >
                <AddIcon />
              </button>
            </div>
            {state.gallery.map((slide, i) => {
              return (
                <div className="content__fields-item" key={i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="Title:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].title`}
                            error={!!errors[`twoForOne.gallery[${i}].title`]}
                            helperText={errors[`twoForOne.gallery[${i}].title`]}
                            onChange={handleChange}
                            value={slide.title}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="Description:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].description`}
                            error={
                              !!errors[`twoForOne.gallery[${i}].description`]
                            }
                            helperText={
                              errors[`twoForOne.gallery[${i}].description`]
                            }
                            onChange={handleChange}
                            value={slide.description}
                          />
                        </Box>
                      }
                    />
                    {state.gallery.length > 1 && (
                      <button
                        className="content__delete-btn"
                        type="button"
                        onClick={() => handleRemoveGalleryItem(i, "twoForOne")}
                      >
                        <RemoveIcon />
                      </button>
                    )}
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 800 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].image800Url`}
                            error={
                              !!errors[`twoForOne.gallery[${i}].image800Url`]
                            }
                            helperText={
                              errors[`twoForOne.gallery[${i}].image800Url`]
                            }
                            onChange={handleChange}
                            value={slide.image800Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 1600 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].image1600Url`}
                            error={
                              !!errors[`twoForOne.gallery[${i}].image1600Url`]
                            }
                            helperText={
                              errors[`twoForOne.gallery[${i}].image1600Url`]
                            }
                            onChange={handleChange}
                            value={slide.image1600Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="image 2048 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].image2048Url`}
                            error={
                              !!errors[`twoForOne.gallery[${i}].image2048Url`]
                            }
                            helperText={
                              errors[`twoForOne.gallery[${i}].image2048Url`]
                            }
                            onChange={handleChange}
                            value={slide.image2048Url}
                          />
                        </Box>
                      }
                    />
                    <CreateContentField
                      fieldTitle="image 3840 URL:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.gallery[${i}].image3840Url`}
                            error={
                              !!errors[`twoForOne.gallery[${i}].image3840Url`]
                            }
                            helperText={
                              errors[`twoForOne.gallery[${i}].image3840Url`]
                            }
                            onChange={handleChange}
                            value={slide.image3840Url}
                          />
                        </Box>
                      }
                    />
                  </div>
                </div>
              );
            })}
          </Collapse>
        </Card>

        <Card className="content__card">
          <span
            className={`content__card-label ${
              collapseState.tfoFaq ? "open" : "close"
            }`}
            onClick={() => toggleCard("tfoFaq")}
          >
            FAQ
          </span>
          <Collapse in={collapseState.tfoFaq}>
            <div className="content__fields-row">
              <CreateContentField
                fieldTitle="ImageURL:"
                field={
                  <Box>
                    <TextField
                      label=""
                      size="small"
                      variant="outlined"
                      type="text"
                      name="twoForOne.faq.imageUrl"
                      error={!!errors[`twoForOne.faq.imageUrl`]}
                      helperText={errors[`twoForOne.faq.imageUrl`]}
                      onChange={handleChange}
                      value={state.faq.imageUrl || ""}
                    />
                  </Box>
                }
              />
            </div>
            <div className="content__fields-row centered">
              <span className="content__item-label">
                FAQs ({state.faq.faqs.length}):
              </span>
              <button
                className="content__add-btn centered"
                type="button"
                onClick={handleAddFaqItem}
              >
                <AddIcon />
              </button>
            </div>
            {state.faq.faqs.map((item, i) => {
              return (
                <div className="content__fields-item" key={item._id || i}>
                  <div className="content__fields-row">
                    <CreateContentField
                      fieldTitle="question:"
                      field={
                        <Box>
                          <TextField
                            label=""
                            size="small"
                            variant="outlined"
                            type="text"
                            name={`twoForOne.faq.faqs[${i}].question`}
                            error={
                              !!errors[`twoForOne.faq.faqs[${i}].question`]
                            }
                            helperText={
                              errors[`twoForOne.faq.faqs[${i}].question`]
                            }
                            onChange={handleChange}
                            value={item.question}
                          />
                        </Box>
                      }
                    />
                    <button
                      className="content__delete-btn"
                      type="button"
                      onClick={() => handleRemoveFaqItem(item._id)}
                    >
                      <RemoveIcon />
                    </button>
                  </div>
                  <div className="content__fields-row centered">
                    <span className="content__item-label">Answers:</span>
                    <button
                      className="content__add-btn centered"
                      type="button"
                      onClick={() => handleAddFaqAnswer(i)}
                    >
                      <AddIcon />
                    </button>
                  </div>
                  {item.answer.map((answer, j) => (
                    <div className="content__fields-list-item" key={j}>
                      <div className="content__fields-row">
                        <CreateContentField
                          fieldTitle=""
                          field={
                            <Box>
                              <TextField
                                label=""
                                size="small"
                                variant="outlined"
                                type="text"
                                name={`twoForOne.faq.faqs[${i}].answer[${j}]`}
                                error={
                                  !!errors[
                                    `twoForOne.faq.faqs[${i}].answer[${j}]`
                                  ]
                                }
                                helperText={
                                  errors[
                                    `twoForOne.faq.faqs[${i}].answer[${j}]`
                                  ]
                                }
                                onChange={handleChange}
                                value={answer}
                              />
                            </Box>
                          }
                        />
                        {item.answer.length > 1 && (
                          <button
                            className="content__delete-btn centered"
                            type="button"
                            onClick={() => handleRemoveFaqAnswer(i, j)}
                          >
                            <RemoveIcon />
                          </button>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </Collapse>
        </Card>
      </Box>
    </div>
  );
};

export default TwoForOneCards;
